module.exports = __webpack_public_path__ + "static/media/Steven Velegrinis.7461e528.jpg";